import { Identifiable, Project } from "@planzone/dto";
import { Filter } from "@planzone/dto";

import { isFilteredByProjects } from "./projects";
import { isFilteredByStatuses } from "./projectStatuses";
import { isFilteredByProjectPortfolios } from "./projectPortfolios";
import { isFilteredByTags } from "./projectsTags";

function isProjectFiltered(
  project: Identifiable<Project>,
  filter: Filter,
): boolean {
  return [
    isFilteredByProjects,
    isFilteredByStatuses,
    isFilteredByProjectPortfolios,
    isFilteredByTags,
  ].reduce(
    (isFiltered, applyFilter) =>
      isFiltered ? isFiltered : applyFilter(project, filter),
    false,
  );
}

export { isProjectFiltered };
